import { Signal } from '@/helpers/objects'
import { REFRESH_MS } from '@leapsight/styleguide'
import store from '@/store'
import { createEntityApiDB } from '@/api/indexDB/entity'
import { TABLE } from '@/constants/tableNames'
import { serializationThingsDB } from '@/api/indexDB/helpers'

class SignalListener {
  private queue: Signal[] = []
  // private queue: Array<Object> = []
  private intervalId?: number

  constructor() {
    this.addSignal = this.addSignal.bind(this)
  }

  public signalFilter(signal) {
    const things = store.getters['mapState/currentThings']
    const thingsArr = Object.keys(things)

    const thingApiDB = createEntityApiDB(TABLE.THINGS)
    let thingToStore = structuredClone(signal)
    thingToStore = serializationThingsDB(thingToStore)
    thingApiDB
      .update({ id: thingToStore.id, entity: thingToStore })
      .catch(e => console.error(e))

    if (thingsArr.length > 0) {
      if (thingsArr.includes(signal.id)) {
        thingsArr.map(key => {
          if (signal.id === things[key].id) {
            if (
              signal.metadata.reported_state.location.timestamp >
              things[key].lastReport
            ) {
              this.queue.push(signal)
            }
          }
        })
      } else {
        this.queue.push(signal)
      }
    } else {
      this.queue.push(signal)
    }
  }

  public addSignal(signals): void {
    signals.forEach(signal => this.signalFilter(signal))
  }

  public fetchAndCleanSignals(): Signal[] {
    const response = this.queue
    this.queue = []
    return response
  }

  public startPolling(addLocations): void {
    this.intervalId = setInterval(() => {
      const signals = this.fetchAndCleanSignals()
      addLocations(signals)
    }, REFRESH_MS)
  }

  public stopPolling(): void {
    if (this.intervalId != null) {
      clearInterval(this.intervalId)
    }
  }
}

const signalListener = new SignalListener()
export { signalListener as SignalListener }
